// import React from "react";
// import { Box, Typography, Grid, Container, Stack, useTheme, useMediaQuery } from "@mui/material";
// import snackImg1 from "./assets/catagorypng/Web_Icons-07.webp";

// function ShopebyCategories() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

//   return (
//     <Box sx={{ backgroundColor: "#fff", py: 10, px: 2 }}>
//       <Container maxWidth="lg">
//         {/* Heading */}
//         <Box textAlign="center" mb={4}>
//           <Typography variant="h4" fontWeight="bold" sx={{ fontSize: { xs: 24, sm: 36, md: 50 } }}>
//             Born from Bhakti, Crafted with Love !
//           </Typography>
//           <Typography variant="subtitle1" sx={{ mt: 2 }}>
//             Offering purity through sacred temple flowers and mindful hands
//           </Typography>
//         </Box>

//         {/* Image Section */}
//         <Grid container justifyContent="center" spacing={4} sx={{ mb: 6 }}>
//           <Grid item xs={20} sm={15} md={12}>
//             <Box
//               component="img"
//               src={snackImg1}
//               alt="snack"
//               sx={{
//                 width: "100%",
//                 maxHeight: 250,
//                 objectFit: "contain",
//                 mx: "auto",
//                 display: "block",
//               }}
//             />
//           </Grid>
//         </Grid>

//         {/* Features */}
//         <Stack
//           direction="row"
//           flexWrap="wrap"
//           justifyContent="center"
//           spacing={2}
//           useFlexGap
//           sx={{
//             "& span": {
//               background: "#f5f5f5",
//               px: 2,
//               py: 1,
//               borderRadius: "20px",
//               fontSize: 16,
//               fontWeight: 500,
//             },
//           }}
//         >
//           <span>♻️ Sustainably Crafted</span>
//           <span>🙏 Spiritually Rooted</span>
//           <span>🎁 Elegantly Designed</span>
//           <span>🌸 Purpose-Driven</span>
//           <span>🪔 Soulfully Fragrant</span>
//           <span>🌿 Earth-Aligned</span>
//         </Stack>
//       </Container>
//     </Box>
//   );
// }

// export default ShopebyCategories;
import React from "react";
import snackImg1 from "./assets/catagorypng/Web_Icons-07.webp";
import { Stack, Typography } from "@mui/material";

function ShopebyCategories() {
  return (
    <div className="bg-white pt-10 pb-8 px-6 sm:px-8 md:px-10">
      
      {/* Heading */}
      <div className="text-center mb-10">
        <h2 className="font-bold text-3xl sm:text-4xl md:text-5xl leading-tight">
          Born from Bhakti, Crafted with Love !
        </h2>
             <Typography variant="subtitle1" sx={{ mt: 2 }}>
            Offering purity through sacred temple flowers and mindful hands
          </Typography>
      </div>

      {/* Responsive Image Container */}
      <div className="flex justify-center">
        <div className="w-full max-w-6xl px-4">
          <div className="flex flex-col items-center rounded-lg hover:shadow-md transition-all">
            <div className="w-full sm:w-[500px] h-auto sm:h-[200px]">
              <img
                src={snackImg1}
                alt="Making Process"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
        <Stack
          direction="row"
          flexWrap="wrap"
          justifyContent="center"
          spacing={2}
          useFlexGap
          sx={{
            "& span": {
              background: "#f5f5f5",
              px: 2,
              py: 1,
              borderRadius: "20px",
              fontSize: 16,
              fontWeight: 500,
            },
          }}
        >
          <span>♻️ Sustainably Crafted</span>
          <span>🙏 Spiritually Rooted</span>
          <span>🎁 Elegantly Designed</span>
          <span>🌸 Purpose-Driven</span>
          <span>🪔 Soulfully Fragrant</span>
          <span>🌿 Earth-Aligned</span>
        </Stack>

    </div>
  );
}

export default ShopebyCategories;
